import React from "react";
import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import { countryCodes } from "../../../../../lib/data/optionItems";
import { sysPrimaryDefault, sysPrimaryHover } from "../../../../../lib/themes/colors";
import { Flex } from "../../../../../styles/utility-components";

type CoreCountriesInputProps<T extends FieldValues> = UseControllerProps<T>;

export default function CoreCountriesInput<T extends FieldValues>(
  props: CoreCountriesInputProps<T>,
) {
  const { field } = useController(props);

  // Sort the country options so that "United Kingdom" is first
  const allCountryOptions = countryCodes
    .filter((country) => country.code === "UK" || country.code === "IE")
    .sort((a, b) => b.name.localeCompare(a.name));

  const handleCountryClick = (country: string) => {
    if (field.value.includes(country)) {
      field.onChange(field.value.filter((c: string) => c !== country));
    } else {
      field.onChange([...field.value, country]);
    }
  };

  return (
    <Container>
      {allCountryOptions.map((country) => {
        return (
          <StyledButton
            key={country.code}
            onClick={() => handleCountryClick(country.name)}
            isSelected={field.value.includes(country.name)}
            buttonType={field.value.includes(country.name) ? "primary" : "secondary"}
          >
            {country.name}
          </StyledButton>
        );
      })}
    </Container>
  );
}

const Container = styled(Flex)({
  gap: 4,
  marginTop: 24,
});

const StyledButton = styled(Button)<{
  isSelected: boolean;
}>`
  background-color: ${({ isSelected }) => isSelected && sysPrimaryDefault};

  &:hover {
    background-color: ${({ isSelected }) => isSelected && sysPrimaryHover};
  }
`;
